module.exports = "https://assets.bwbx.io/s3/reg2/images/favicon-96x96-43336599121809e64bb2.png";